// export enum DeviceTypes {
//     VrtDevice = 'VrtDeviceType',
//     TornDevice = 'TornDeviceType',
//     GarDevice = 'GarDeviceType',
//     CetDevice = 'CetDeviceType',
//     SacDevice = 'SacDeviceType',
//     CauDevice = 'CauDeviceType',
//     PosDevice = 'PosDeviceType',
//     GranjaDevice = 'GranjaDeviceType',
//     defaultDevice = 'DefaultDeviceType',
// }
// export interface IVrtDevice {
//     SamId: string;
//     NumberDevice: string;
//     RouteName: string;
//     Observations: string;
//     WhiteList: boolean;
//     Issued: boolean;
//     ProjectId: number;
//     StationId: number;
//     TechnologicalOperatorId: number;
//     routeId: number;
// }


// export const objAsVrtDevice: IVrtDevice = {
//     SamId: '',
//     ProjectId: 0,
//     NumberDevice: '',
//     RouteName: '',
//     Observations: '',
//     WhiteList: false,
//     Issued: false,
//     StationId: 0,
//     TechnologicalOperatorId: 0,
//     routeId: 0,
// };

// export interface ICetDevice {
//     SamId: string;
//     NumberDevice: string;
//     RouteId: number;
//     EconomicNumberId: number;
//     CarPlates: string;
//     Observations: string;
// }


// export const objAsCetDevice: ICetDevice = {
//     SamId: '',
//     NumberDevice: '',
//     RouteId: 0,
//     EconomicNumberId: 0,
//     CarPlates: '',
//     Observations: '',
// }

// export interface IPosDevice {
//     SamId: string;
//     NumberDevice: string;
//     PointOfSaleId: number;
//     Address: string;
//     Observations: string;
//     LocationId: string;
//     StationId: string

// }


// export const objAsPosDevice: IPosDevice = {
//     SamId: '',
//     NumberDevice: '',
//     PointOfSaleId: 0,
//     Address: '',
//     Observations: '',
//     LocationId: '',
//     StationId: ''
// }

// export interface ICauDevice {
//     SamId: string;
//     NumberDevice: string;
//     Address: string;
//     Observations: string;
//     LocationId: string;
//     StationId: string
// }


// export const objAsCauDevice: ICauDevice = {
//     SamId: '',
//     NumberDevice: '',
//     Address: '',
//     Observations: '',
//     LocationId: '',
//     StationId: ''
// }

// export interface IGranjaDevice {
//     SamId: string;
//     NumberDevice: string;
//     IdSocket: string;
//     Address: string;
//     Observations: string;
// }


// export const objAsGranjaDevice: IGranjaDevice = {
//     SamId: '',
//     NumberDevice: '',
//     IdSocket: '',
//     Address: '',
//     Observations: '',
// }

// export interface IDefaultForm {
//     DeviceType: string;
//     Station: string
//     LocationId: string;
// }

// export const objAsDefaultForm: IDefaultForm = {
//     DeviceType: '',
//     Station: '',
//     LocationId: '',
// }



interface SamFormValues {
    Id: number | null;
    SamId: string;
    WhiteList: boolean;
    Issued: boolean;
    IssuedPhase2: boolean | null;
    IssueOrderId: number | null;
    InventoryOrderId: number | null;
    LocationGpsObject: string;
    ProjectId: number | null;
    Project: string;
    LocationId: string;
    StationId: number | null;
    Station: string;
    RouteId: number | null;
    RouteName: string;
    RouteNumber: string;
    PcModuleId: number | null;
    PCModules: any; // ajusta según el tipo real
    PointOfSaleId: number | null;
    PointOfSale: any; // ajusta según el tipo real
    DeviceTypeId: number | null;
    DeviceType: string;
    DeviceTypeEnum: number | null;
    SamTypeId: number | null;
    SamType: string;
    SamStatus: string;
    SamStatusEnum: number | null;
    TransportCompanyId: number | null;
    TransportCompanyName: string;
    TransportCompanyEUR: string;
    TechnologicalOperatorId: number | null;
    TechnologicalOperator: string;
    EconomicNumberId: number | null;
    EconomicNumber: string;
    Name: string;
    SamActivatedBy: string;
    CreatedBy: string;
    CreatedOn: string;
    CreatedFrom: string;
    ActivatedBy: string;
    ActivatedOn: string;
    Observations: string;
    CarPlates: string;
    Address: string;
    IdSocket: string | null;
    NumberDevice: string;
    KeyVersion: string;
    isSandbox: boolean;
    AmountTransactionAdditional: number | null;
    HistoryEntries: any; // ajusta según el tipo real
    Counters: any[];     // ajusta según el tipo real
    IssueOrder: any;     // ajusta según el tipo real
    InventoryOrder: any; // ajusta según el tipo real
}



export const initialValuesInventoryFormik: SamFormValues = {
    Id: null,
    SamId: '',
    WhiteList: false,
    Issued: false,
    IssuedPhase2: null,
    IssueOrderId: null,
    InventoryOrderId: null,
    LocationGpsObject: '',
    ProjectId: null,
    Project: '',
    LocationId: '',
    StationId: null,
    Station: '',
    RouteId: null,
    RouteName: '',
    RouteNumber: '',
    PcModuleId: null,
    PCModules: null,
    PointOfSaleId: null,
    PointOfSale: null,
    DeviceTypeId: null,
    DeviceType: '',
    DeviceTypeEnum: null,
    SamTypeId: null,
    SamType: '',
    SamStatus: '',
    SamStatusEnum: null,
    TransportCompanyId: null,
    TransportCompanyName: '',
    TransportCompanyEUR: '',
    TechnologicalOperatorId: null,
    TechnologicalOperator: '',
    EconomicNumberId: null,
    EconomicNumber: '',
    Name: '',
    SamActivatedBy: '',
    CreatedBy: '',
    CreatedOn: '',
    CreatedFrom: '',
    ActivatedBy: '',
    ActivatedOn: '',
    Observations: '',
    CarPlates: '',
    Address: '',
    IdSocket: null,
    NumberDevice: '',
    KeyVersion: '',
    isSandbox: false,
    AmountTransactionAdditional: null,
    HistoryEntries: null,
    Counters: [],
    IssueOrder: null,
    InventoryOrder: null,
};


import * as Yup from 'yup';

export const validationSchemaInventory = Yup.object().shape({
    NumberDevice: Yup.string().required('El número de dispositivo es obligatorio'),
});